import { QueryClient } from "@tanstack/react-query";

// TECH-01: single QueryClient tuned so stale-data UX mirrors the server cache.
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // ~mirror of CACHE_TTL_SECONDS (default 5 min) — keeps client revalidation
      // aligned with what the server is actually serving.
      staleTime: 5 * 60 * 1000,
      gcTime: 30 * 60 * 1000,
      retry: (failureCount, error) => {
        if (error instanceof Response && error.status >= 400 && error.status < 500) return false;
        return failureCount < 2;
      },
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: 0,
    },
  },
});
